export const FORM_NAMES = {
    SEND_FORM_NAME: 'send',
    REQUEST_FORM_NAME: 'request',
    OFAKIM_FORM_NAME: 'ofakim',
    FILTER_FORM_NAME: 'filter',
    EMAIL_POPUP_FORM_NAME: 'emailPopup',
    ANTIFRAUD_HRJ: 'antifraudHrj',
    ANTIFRAUD_CVV: 'antifraudCvv',
    ANTIFRAUD_SUM_VERIFICATION: 'antifraudSumVerification',
    PROFILE_FORM_NAME: 'profile',
    PROFILE_EDIT_FORM_NAME: 'profileEdit',
    SMS_ON_SUCCESS_PAY_FORM_NAME: 'smsOnSuccessPay',
    FEEDBACK_FORM_NAME: 'feedback',
    ADD_SOURCE_BANK_ACCOUNT: 'addBankAccount',
    ADD_SOURCE_BANK_CARD: 'addBankCard',
    LOGIN_REGISTRATION_FORM_NAME: 'loginRegistration',
    CHECK_BIRTHDAY_FORM_NAME: 'checkBirthday',
    SMS_CONFIRMATION_FORM_NAME: 'smsConfirmation',
    PASSCODE_FORM_NAME: 'passcodeForm',
    CHANGE_PHONE_NUMBER: 'changePhoneNumber',
    CHANGE_EMAIL: 'changeEmail',
    PROFILE_NOTIFICATION: 'profileNotification',
    AML_LEVEL_FORM: 'aml_level_form',
    PROFILE_USA_OCCUPATION: 'profileUsaOccupation',
    CONFIRM_CARD_BY_AMOUNT: 'confirmCardByAmount',
    CONFIRM_CARD_BY_CODE: 'confirmCardByCode',
    TOP_UP_ACCOUNT: 'topUpAccount',
    CHANGE_PIN_FORM_NAME: 'changePin',
    GA_SEND_FORM_NAME: 'gaSend',
    GA_EXCHANGE_FORM_NAME: 'gaExchange',
    GA_ACTIVITY: 'gaActivity',
    GA_ORDER_PLASTIC_CARD_PIN: 'gaOrderPlasticCardPin',
    GA_ORDER_PLASTIC_CARD_ADDRESS: 'gaOrderPlasticCardAddress',
    GA_ORDER_PLASTIC_CARD_DIGITS: 'gaOrderPlasticCardDigits',
    SUGGESTED: 'suggested',
    ADD_REQUEST_ACQUIRING: 'addRequestAcquiring',
    ADD_CANDIDATE: 'addCandidate',
    FINISH_REGISTRATION: 'finishRegistration',
    KYC_UZBEKISTAN_FORM_NAME: 'kycUzbekistan',
    KYC_EMIRATES_FORM_NAME: 'kycEmirates',
    PLUS_UNSUBSCRIBE_FORM_NAME: 'plusUnsubscribe',
    PURPOSE_ACCOUNT_FORM_NAME: 'purposeOfAccount',
    PLUS_SUBSCRIBE_FORM_NAME: 'subscribe_form',
    PLUS_CHANGE_PLAN_FORM_NAME: 'change_plan_form',
    FEEDBACK_CANCELLATION_REASONS: 'feedbackCancellationReasons',
    PRECHEQUE_FORM: 'precheque_form',
    TRANSFER_STATEMENT: 'transfer_statement',
    NO_AUTH_LOGIN_REGISTRATION_FORM_NAME: 'noAuthLoginRegistration',
    ONBOARDING_QUESTIONNAIRE: 'onboardingQuestionnaire',
} as const;

export type FormNameKey = keyof typeof FORM_NAMES;
export type FormNameValue = (typeof FORM_NAMES)[FormNameKey];

export const {
    SEND_FORM_NAME,
    REQUEST_FORM_NAME,
    OFAKIM_FORM_NAME,
    FILTER_FORM_NAME,
    EMAIL_POPUP_FORM_NAME,
    ANTIFRAUD_HRJ,
    ANTIFRAUD_CVV,
    ANTIFRAUD_SUM_VERIFICATION,
    PROFILE_FORM_NAME,
    PROFILE_EDIT_FORM_NAME,
    SMS_ON_SUCCESS_PAY_FORM_NAME,
    FEEDBACK_FORM_NAME,
    ADD_SOURCE_BANK_ACCOUNT,
    ADD_SOURCE_BANK_CARD,
    LOGIN_REGISTRATION_FORM_NAME,
    CHECK_BIRTHDAY_FORM_NAME,
    SMS_CONFIRMATION_FORM_NAME,
    PASSCODE_FORM_NAME,
    CHANGE_PHONE_NUMBER,
    CHANGE_EMAIL,
    PROFILE_NOTIFICATION,
    AML_LEVEL_FORM,
    PROFILE_USA_OCCUPATION,
    CONFIRM_CARD_BY_AMOUNT,
    CONFIRM_CARD_BY_CODE,
    TOP_UP_ACCOUNT,
    CHANGE_PIN_FORM_NAME,
    GA_SEND_FORM_NAME,
    GA_EXCHANGE_FORM_NAME,
    GA_ACTIVITY,
    GA_ORDER_PLASTIC_CARD_PIN,
    GA_ORDER_PLASTIC_CARD_ADDRESS,
    GA_ORDER_PLASTIC_CARD_DIGITS,
    SUGGESTED,
    ADD_REQUEST_ACQUIRING,
    ADD_CANDIDATE,
    FINISH_REGISTRATION,
    KYC_UZBEKISTAN_FORM_NAME,
    KYC_EMIRATES_FORM_NAME,
    PLUS_UNSUBSCRIBE_FORM_NAME,
    PURPOSE_ACCOUNT_FORM_NAME,
    PLUS_SUBSCRIBE_FORM_NAME,
    PLUS_CHANGE_PLAN_FORM_NAME,
    FEEDBACK_CANCELLATION_REASONS,
    PRECHEQUE_FORM,
    TRANSFER_STATEMENT,
    NO_AUTH_LOGIN_REGISTRATION_FORM_NAME,
    ONBOARDING_QUESTIONNAIRE,
} = FORM_NAMES;
